<template>
  <b-modal
    id="edit-member"
    ref="edit-member"
    size="md-size"
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="content-wrapper">
      <div class="member">
        <div class="pic-wrap">
          <span
            v-if="!member.avatar"
            class="initials"
          >{{ member.initials }}</span>
          <img
            v-if="member.avatar"
            :src="member.avatar"
            width="40"
            height="40"
            class="member-pic"
          >
        </div>
        <div class="member-wrap">
          <h4 class="member-name">
            {{ member.name }}
          </h4>
          <span class="email">{{ member.email }}</span>
        </div>
      </div>
      <hr class="m-sp">
      <div class="member-settings">
        <div
          v-if="departmentEnabled"
          class="setting half"
          :class="{'order-null': !departmentEnabled}"
        >
          <span class="heading-title">{{ label.get('department') }}</span>
          <select-dropdown-component
            :value="department"
            :options="departments"
            @onOptionSelected="onDepartmentChanged"
          />
        </div>
        <div class="setting half">
          <span class="heading-title">{{ label.get('role') }}</span>
          <span
            v-if="!canChangeRole"
            class="inactive"
          >{{ getRoleLabel() }}</span>
          <select-dropdown-component
            v-if="canChangeRole"
            :value="member.role_id"
            :options="roles"
            @onOptionSelected="onRoleChanged"
          />
        </div>
        <div
          class="setting"
          :class="{'half order-two': !departmentEnabled}"
        >
          <span class="heading-title">{{ label.get('overtime') }}</span>
          <select-dropdown-component
            :value="member.user_settings.settings.overtime"
            :options="overtimes"
            @onOptionSelected="onOvertimeChanged"
          />
        </div>
        <div
          v-if="member.user_settings.settings.overtime.toLowerCase() !== 'none'"
          class="setting"
          :class="{'half order-three': !departmentEnabled, 'has-error': hoursHasError}"
        >
          <span class="heading-title">Hours</span>
          <time-picker-component
            v-show="member.user_settings.settings.overtime.toUpperCase() === 'DAILY'"
            v-model="member.user_settings.settings.h_in_day"
            :format24h="true"
            :required="true"
          />
          <time-picker-component
            v-show="member.user_settings.settings.overtime.toUpperCase() === 'WEEKLY'"
            v-model="member.user_settings.settings.h_in_week"
            :format24h="true"
            :unlimited-hours="true"
            :required="true"
          />
        </div>
        <div
          class="setting lt"
          :class="{'half order-one': !departmentEnabled}"
        >
          <span class="heading-title">{{ label.get('location_tracking') }}</span>
          <div class="check-wrapper">
            <b-form-checkbox
              v-model="member.user_settings.location_tracking_enabled"
              name="checkbox-1"
            >
              {{ label.get('required') }}
            </b-form-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="reset"
        class="atto-btn cancel"
        @click="close"
      >
        {{ label.get('cancel') }}
      </button>
      <button
        type="reset"
        class="atto-btn submit"
        :disabled="disableSaveChangesButton"
        @click="saveChanges"
      >
        {{ label.get('save_changes') }}
      </button>
    </div>
  </b-modal>
</template>

<script>

    import SelectDropdownComponent from '../../../../shared/components/SelectDropdownComponent';
    import TimePickerComponent from "../../../timesheets/shared/components/TimePickerComponent";
    import MemberService from "../services/MemberService";

    export default {
        name: "EditTeamMemberComponent",
        components: {
            SelectDropdownComponent,
            TimePickerComponent
        },
        props: {
            member: {
              type: Object,
              default: () => {
                return {};
              }
            }
        },
        data() {
            let departments = this.$store.state.companyDepartments.map(item => {
                return {
                    value: item.id,
                    label: item.name
                };
            });

            departments.unshift({
                value: -1,
                label: this.label.get('no_department')
            });

            return {
                departmentEnabled: this.$store.state.companySettings.enable_departments,
                departments: departments,
                department: this.member.department_id ? this.member.department_id : -1,
                dailyOvertime: this.member.user_settings.settings.overtime.toUpperCase() === 'DAILY',
                weeklyOvertime: this.member.user_settings.settings.overtime.toUpperCase() === 'WEEKLY',
                hoursInDay: this.member.user_settings.settings.h_in_day,
                hoursInWeek: this.member.user_settings.settings.h_in_week,
                oldMember: JSON.parse(JSON.stringify(this.member)),
                disableSaveChangesButton: false,
                hoursHasError: false,
                roles: [
                    {
                        value: 1,
                        label: this.label.get('admin')
                    },
                    {
                        value: 2,
                        label: this.label.get('manager')
                    },
                    {
                        value: 3,
                        label: this.label.get('employee')
                    }
                ],
                overtimes: [
                    {
                        value: 'None',
                        label: this.label.get('overtime_no_overtime'),
                    },
                    {
                        value: 'Daily',
                        label: this.label.get('daily'),
                    },
                    {
                        value: 'Weekly',
                        label: this.label.get('weekly'),
                    }
                ]
            };
        },
        computed: {
            canChangeRole() {
                if(this.$store.state.user.id !== this.member.id) {
                    if(this.$store.state.user.id === this.$store.state.company.user_id) {
                        return true;
                    } else if (this.$store.state.user.role_id < this.member.role_id) {
                        return true;
                    }
                }
                return false;
            }
        },
        mounted() {
            document.body.appendChild(this.$el);
            this.$refs['edit-member'].show();
        },
        methods: {
            getRoleLabel() {
                if (this.member.id === this.$store.state.company.user_id) {
                    return this.label.get('owner');
                }
                if (this.member.role_id === 1) {
                    return this.label.get('admin');
                }
                if (this.member.role_id === 2) {
                    return this.label.get('manager');
                }
                if (this.member.role_id === 3) {
                    return this.label.get('employee');
                }
                return this.label.get('employee');
            },

            onRoleChanged(option) {
                this.member.role_id = option.value;
            },

            onDepartmentChanged(option) {
                this.department = option.value;
                this.member.department_id = option.value;
            },

            onOvertimeChanged(option) {
                this.member.user_settings.settings.overtime = option.value;
            },

            saveChanges() {

                this.hoursHasError = false;
                if(this.member.user_settings.settings.overtime.toUpperCase() === 'DAILY' && !this.areValidHoursInDay()) {
                    this.hoursHasError = true;
                    return false;
                }
                if(this.member.user_settings.settings.overtime.toUpperCase() === 'WEEKLY' && !this.areValidHoursInWeek()) {
                    this.hoursHasError = true;
                    return false;
                }

                let hasChanges = false;
                this.disableSaveChangesButton = true;
                if(this.member.role_id !== this.oldMember.role_id || this.department !== this.oldMember.department_id) {
                    hasChanges = true;
                    if(this.member.role_id !== this.oldMember.role_id) {
                        this.$store.commit('showLoading');
                        MemberService.changeMemberRole({
                            user_id: this.member.id,
                            role_id: this.member.role_id
                        }).then((result) => {
                            this.$store.commit('hideLoading');
                            this.$root.$emit('hideEditMember');
                        }).catch((error) => {
                            this.disableSaveChangesButton = false;
                            this.$store.commit('hideLoading');
                        });
                    }

                    if(this.department !== this.oldMember.department_id) {
                        if(this.department !== undefined && this.department !== null && this.department > 0) {
                            this.$store.commit('showLoading');
                            MemberService.addMemberToDepartment({
                                user_id: this.member.id,
                                department_id: this.department
                            }).then((result) => {
                                this.member.department_id = this.department;
                                this.member.department = this.$store.state.companyDepartments.find((d) => { return d.id === this.department});
                                this.$store.commit('hideLoading');
                                this.$root.$emit('hideEditMember');
                            }).catch((error) => {
                                this.disableSaveChangesButton = false;
                                this.$store.commit('hideLoading');
                            });
                        } else if (this.department === -1 && this.oldMember.department_id !== null) {
                            this.$store.commit('showLoading');
                            MemberService.deleteMemberFromDepartment({
                                user_id: this.member.id
                            }).then(() => {
                                this.member.department = null;
                                this.$store.commit('hideLoading');
                                this.$root.$emit('hideEditMember');
                            }).catch(() => {
                                this.disableSaveChangesButton = false;
                                this.$store.commit('hideLoading');
                            });
                        }
                    }
                }
                if(this.member.user_settings.settings.overtime !== this.oldMember.user_settings.settings.overtime
                    || this.member.user_settings.settings.h_in_day !== this.oldMember.user_settings.settings.h_in_day
                    || this.member.user_settings.settings.h_in_week !== this.oldMember.user_settings.settings.h_in_week
                    || this.member.user_settings.location_tracking_enabled !== this.oldMember.user_settings.location_tracking_enabled) {

                    if(this.member.user_settings.settings.overtime.toUpperCase() === 'NONE' && this.member.user_settings.settings.h_in_day === "") {
                        this.member.user_settings.settings.h_in_day = this.hoursInDay;
                    }
                    if(this.member.user_settings.settings.overtime.toUpperCase() === 'NONE' && this.member.user_settings.settings.h_in_week === "") {
                        this.member.user_settings.settings.h_in_week = this.hoursInWeek;
                    }

                    if(this.member.user_settings.settings.h_in_day.length === 8) {
                      this.member.user_settings.settings.h_in_day = this.$moment(this.member.user_settings.settings.h_in_day, 'HH:mm:ss').format("HH:mm");
                    }
                    if(this.member.user_settings.settings.h_in_week.length === 8) {
                      this.member.user_settings.settings.h_in_week = this.$moment(this.member.user_settings.settings.h_in_week, 'HH:mm:ss').format("HH:mm");
                    }

                    hasChanges = true;
                    this.$store.commit('showLoading');
                    MemberService.updateMemberSettings(this.member.user_settings).then(() => {
                        this.$store.commit('hideLoading');
                        this.$root.$emit('hideEditMember');
                    }).catch(() => {
                        this.disableSaveChangesButton = false;
                        this.$store.commit('hideLoading');
                    });
                }
                if(!hasChanges){
                    this.$root.$emit('hideEditMember');
                }
            },

            areValidHoursInDay() {
                const dayHours = this.member.user_settings.settings.h_in_day;
                if (dayHours.length <= 5) {
                    const dayHoursRegexp = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/;
                    const dayHoursMatch = dayHoursRegexp.exec(dayHours);
                    if (dayHoursMatch === null) {
                        return false;
                    }
                }
                return true;
            },

            areValidHoursInWeek() {
                const weekHours = this.member.user_settings.settings.h_in_week;
                if (weekHours.length <= 5) {
                    const weekHoursRegexp = /^([0-9]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/;
                    const weekHoursMatch = weekHoursRegexp.exec(weekHours);
                    if (weekHoursMatch === null) {
                        return false;
                    }
                }
                return true;
            },

            close: function () {
                this.$root.$emit('hideEditMember');
            }
        }
    }
</script>

<style lang="scss">

    .modal-md-size {
        .member {
            display: flex;
            flex-direction: row;
            padding-top: 40px;
            padding-bottom: 32px;

            .pic-wrap{
                width: 40px;
                height: 40px;
                border-radius: 100%;
                margin-right: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                align-content: center;

                i.atto-avatar{
                    font-size: 40px;
                }

                span.initials {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 0.875rem;
                    line-height: 1.5rem;
                    font-weight: 400;
                    font-family: "Roboto", sans-serif;
                    color: #999;
                    background-color: #efefef;
                    border-radius: 100%;
                    width: 100%;
                    height: 100%;
                    text-transform: uppercase;
                }

                img{
                    border-radius: 100%;
                }
            }

            .member-wrap {
                width: 220px;
                margin-right: 19px;
                display: inline-flex;
                flex-direction: column;
                align-items: flex-start;

                .member-name {
                    color: #262626;
                    font-family: "Roboto", sans-serif;
                    font-size: 1rem;
                    font-weight: 500;
                    line-height: 1.5rem;
                }

                .email {
                    display: inline-flex;
                    color: #999;
                    font-family: "Roboto", sans-serif;
                    font-size: 0.75rem;
                    font-weight: 400;
                    line-height: 1.5rem;
                    margin-top: -4px;
                }
            }
        }


        hr.m-sp {
            margin: 0 0 32px;
            border: 0;
            height: 2px;
            background-color: #efefef;
        }

        .member-settings {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;

            .setting {
                width: calc(33.3333% - 12px);
                margin-bottom: 24px;

                &.half {
                    width: calc(50% - 8px);
                }

                span.inactive{
                    color: #262626;
                    font-family: "Roboto", sans-serif;
                    font-size: 0.875rem;
                    font-weight: 400;
                    line-height: 1.5rem;
                    display: inline-flex;
                    width: 100%;
                    padding: 8px 0px 8px 10px;
                }

                span.heading-title {
                    color: #C7C7C7;
                    font-family: "Roboto", sans-serif;
                    font-size: 0.75rem;
                    font-weight: 500;
                    line-height: 1.5rem;
                    margin-bottom: 4px;
                    display: inline-flex;
                    width: 100%;
                }

                .check-wrapper {
                    min-height: 40px;
                    display: inline-flex;
                    width: 100%;
                    align-items: center;

                    .custom-checkbox {
                        padding-left: 0;

                        .custom-control-label {
                            font-weight: 400;
                            padding-left: 26px;
                            font-size: 0.875rem;
                            line-height: 1.5rem;

                            &:before {
                                left: 0;
                            }
                        }

                        .custom-control-input:checked ~ .custom-control-label::after {
                            left: 0;
                        }
                    }
                }

                input.timepicker {
                    width: 100%;
                }

                &.order-null {
                    order: 0;
                }

                &.order-one {
                    order: 1;
                }

                &.order-two {
                    order: 2;
                }

                &.order-three {
                    order: 3;
                }

                &.has-error{
                    input{
                        border-color: #E05656
                    }
                }
            }
        }
    }
</style>